import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const VaOnboardingSpotlight = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "va-reporting-onboarding" */ './va-reporting-onboarding')),
    LoadingSkeleton: () => null,
});
